document.addEventListener('DOMContentLoaded', (event) => {
  const tz = Moment.tz.guess();
  return Cookies.set('browser.timezone', tz, {
    expires: 365,
    path:    '/',
  });
});
